/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Map_Embed_InvalidInputs */

const vi_error_shop_map_embed_invalid = /** @type {(inputs: Error_Shop_Map_Embed_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ nhận link nhúng Google Maps: trên Google Maps chọn Chia sẻ → Nhúng bản đồ, rồi dán link trong src (bắt đầu bằng https://www.google.com/maps/embed).`)
};

/**

* @param {Error_Shop_Map_Embed_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_map_embed_invalid = /** @type {((inputs?: Error_Shop_Map_Embed_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Map_Embed_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_map_embed_invalid(inputs)
});